:host {
  display: block;
  
  .status-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 0.3rem 0.5rem;
    background-color: #f5f5f5;
    border-bottom: 1px solid #e5e5e5;
    box-shadow: 0 1px 0 rgb(0 0 0 / 5%);
    z-index: 1;
  }
}
